import React, { FC } from "react";
import style from "./style.scss";
import { ThemeBuilderSectionLine } from "./ThemeBuilderSectionLine";
import { WidgetValuePicker, WidgetValuePickerChildrenProps } from "./WidgetValuePicker";

export interface WidgetFontStylePickerProps {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly disabled?: boolean;
    onChange(value: string): void;
}

export const WidgetFontStylePickerRaw: FC<WidgetValuePickerChildrenProps<string>> = props => {

    const value = props.value;
    const italic = !!value && (value.indexOf("italic") >= 0);

    function handleItalicChange(event: React.ChangeEvent<HTMLInputElement>) {
        props.onChange(event.target.checked ? "italic" : "");
    }

    return (
        <label className={style.fontStyleValue}>
            <input type="checkbox" checked={italic} disabled={props.override || props.disabled} onChange={handleItalicChange} />{" "}Italic
        </label>
    );
};

export const WidgetFontStylePicker: FC<WidgetFontStylePickerProps> = props => {
    return (
        <ThemeBuilderSectionLine label={props.label ?? "Font style"}>
            <WidgetValuePicker<string> key="value" value={props.value} defaultValue={props.defaultValue} children={WidgetFontStylePickerRaw} disabled={props.disabled} onChange={props.onChange} />
        </ThemeBuilderSectionLine>
    );
};
